import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPublic as getChannel } from 'widget/redux/server/actions/channel/get-public';

import DataLoader from 'shared/data-components/_data-loader';


@connect(null, {
  getChannel,
})
export default class ChannelLoader extends DataLoader {

  static displayName = 'ChannelLoader';
  static propTypes = {
    getChannel: PropTypes.func,
    channelId: PropTypes.string,
  };

  dependencies = [
    'channelId',
  ];

  loadData() {
    const { channelId, getChannel } = this.props;

    if (!channelId) {
      return;
    }

    // TODO: move getChannel code here
    return getChannel(channelId);
  }

  get childProps() {
    return {
      channel: { fetch: this.loadDataDebounced },
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/channel.js